import { Navigate, Route, Routes } from 'react-router-dom';

import { NotFound } from 'common/components';

import ReceiptLayout from './components/ReceiptLayout';
import { RECEIPT_ROUTES } from './routes';
import CreateReceiptDashboard from './components/Dashboard';
import AgentReceiptDashboard from './components/AgentReceiptDashboard';
import ReceiptPending from './components/ReceiptPending';
//import { PendingReceiptPayload, ReceiptPayload } from 'api/receipt';

//import ResetPassword from './containers/ResetPassword';

const ReceiptContainer = () => (
  <Routes>
    <Route element={<ReceiptLayout />}>
      <Route index element={<Navigate replace to={RECEIPT_ROUTES.dashboard.to} />} />
      <Route
        path={RECEIPT_ROUTES.receiptdashboard.path}
        element={
          <AgentReceiptDashboard
          // isLoading={false}
          // onSubmit={function (): Promise<void> {
          //   throw new Error('Function not implemented.');
          // }}
          />
        }
      />
      <Route path={RECEIPT_ROUTES.dashboard.path} element={<CreateReceiptDashboard />} />
      <Route
        path={RECEIPT_ROUTES.pendingreceipt.path}
        element={
          <ReceiptPending
            isLoading={false}
            onSubmit={function (): Promise<void> {
              throw new Error('Function not implemented.');
            }}
          />
        }
      />
      {/* <Route path={AUTH_ROUTES.signUp.path} element={<SignUp />} /> */}
      {/* <Route path={AUTH_ROUTES.forgottenPassword.path} element={<ForgottenPassword />} /> */}
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default ReceiptContainer;
